// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2OsEL","footer":"ModalError_footer__1Q3oO"};